import React from "react";

const BlogFeatured = () => (
   <section className="w-full bg-white py-12 px-6">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row gap-8 items-center">
         {/* Image */}
         <div className="flex-1">
            <img
               src="/IROKO_IMAGE/image.png"
               alt="Tuteur aidant un élève"
               className="rounded-2xl shadow-lg w-full"
            />

         </div>
         {/* Texte */}
         <div className="flex-1 text-center md:text-left">
            <span className="text-sm text-blue-1 font-semibold uppercase">
               Projets & Tutoriaux
            </span>
            <h2 className="text-2xl font-bold text-dark-1 mt-2">
               Comment nos jeunes Makers ont construit une borne d’arcade en 5 jours
            </h2>
            <p className="text-light-1 mt-3">
               Une aventure collective qui montre le pouvoir du "learning by making". Découvrez
               les étapes, les défis et les réussites de ce projet incroyable.
            </p>
            <button className="mt-5 px-6 py-2 rounded-full border-2 border-red-4 bg-red-4 text-white
            hover:bg-white hover:text-red-4 transition">
               Lire l’article
            </button>
         </div>
      </div>
   </section>
);

export default BlogFeatured;
